import { AudioPlayer } from '../../../../../components';

export const CallTranscript = () => (
  <div className="flex flex-col h-full min-h-0 relative justify-between overflow-y-auto">
    <div className="flex-1 overflow-y-auto p-2 pb-16">
      <div className="flex flex-col gap-y-2">
        <div className="bg-purple-50 p-2 rounded text-tiny">
          <div className="block text-purple-600 mb-1 font-medium">Agent</div>
          <p className="text-tiny">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </p>
        </div>
        <div className="p-2 text-tiny mt-2">
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </div>
    </div>

    <div className="flex items-center justify-between p-4 border-t border-gray-200 bg-white absolute bottom-0 left-0 right-0">
      <div className="flex items-center gap-x-2">
        <AudioPlayer src="https://www.w3schools.com/html/mov_bbb.mp4" />
      </div>
      <a className="text-purple-600 underline text-tiny" href="#">
        Details
      </a>
    </div>
  </div>
);
